import { useSelector } from 'react-redux'
import { selectUser } from '../redux/slices/user.slice'

export const useUser = () => {
  return useSelector(selectUser)
}